<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'QueueLabel',

    functional: true,

    props: {
        queue: {type: Object, default: null},
        href: {type: String, default: null},
        hideIcon: {type: Boolean},
        largeIcon: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        const isProof = props.queue && props.queue.id > 0 && props.queue.is_proof;

        const children = (isProof)
            ? [
                ' ',
                createElement('span', {staticClass: 'badge badge-info'}, [parent.$t('queues.proof-badge')]),
            ]
            : null;

        const iconClass = 'fa fa-fw fa-tasks' + (props.largeIcon ? ' fa-lg' : '');

        data.props = {
            item: props.queue,
            hideIcon: props.hideIcon,
            iconClass: iconClass,
            href: props.href,
            none: parent.$t('queues.nil'),
        };

        return createElement(DataLabel, data, children);
    },
};
</script>
